(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.ar = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      datepicker: {
        apply: 'Apply',
        // to be translated
        clearSelection: 'Clear selection',
        // to be translated
        pickADays: 'Select days',
        // to be translated
        now: 'الآن',
        today: 'اليوم',
        cancel: 'إلغاء',
        clear: 'إزالة',
        confirm: 'موافق',
        selectDate: 'أختر التاريخ',
        selectTime: 'أختر الوقت',
        startDate: 'تاريخ البدء',
        startTime: 'وقت البدء',
        endDate: 'تاريخ الانتهاء',
        endTime: 'وقت الانتهاء',
        prevYear: 'Previous Year',
        // to be translated
        nextYear: 'Next Year',
        // to be translated
        prevMonth: 'Previous Month',
        // to be translated
        nextMonth: 'Next Month',
        // to be translated
        year: '',
        month1: 'يناير',
        month2: 'فبراير',
        month3: 'مارس',
        month4: 'ابريل',
        month5: 'مايو',
        month6: 'يونيو',
        month7: 'يوليو',
        month8: 'أغسطس',
        month9: 'سبتمبر',
        month10: 'أكتوبر',
        month11: 'نوفمبر',
        month12: 'ديسمبر',
        week: 'أسبوع',
        weeks: {
          sun: 'الأحد',
          mon: 'الأثنين',
          tue: 'الثلاثاء',
          wed: 'الأربعاء',
          thu: 'الخميس',
          fri: 'الجمعة',
          sat: 'السبت'
        },
        months: {
          jan: 'يناير',
          feb: 'فبراير',
          mar: 'مارس',
          apr: 'أبريل',
          may: 'مايو',
          jun: 'يونيو',
          jul: 'يوليو',
          aug: 'أغسطس',
          sep: 'سبتمبر',
          oct: 'أكتوبر',
          nov: 'نوفمبر',
          dec: 'ديسمبر'
        },
        pickADay: 'حدد يوما'
      },
      select: {
        loading: 'جار التحميل',
        noMatch: 'لايوجد بيانات مطابقة',
        noData: 'لايوجد بيانات',
        placeholder: 'أختر'
      },
      pagination: {
        goto: 'أذهب إلى',
        pagesize: '/صفحة',
        total: 'الكل {total}',
        pageClassifier: ''
      },
      upload: {
        delete: 'حذف',
        preview: 'عرض',
        continue: 'إستمرار'
      },
      table: {
        emptyText: 'لايوجد بيانات',
        confirmFilter: 'تأكيد',
        resetFilter: 'حذف',
        clearFilter: 'الكل',
        sumText: 'المجموع'
      },
      tree: {
        emptyText: 'لايوجد بيانات'
      }
    }
  };
  _exports.default = _default;
});